
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"800","height":"400","viewBox":"0 0 16 8"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#002395","d":"M0 0h16v8H0z"}}),_c('path',{attrs:{"d":"M4.24 0h8v8z","fill":"#fecb00"}}),_c('g',{attrs:{"id":"b"}},[_c('path',{attrs:{"d":"M2.353.525L2.8-.85 3.247.525l-1.17-.85h1.446z","fill":"#fff","id":"a"}}),_c('use',{attrs:{"xlink:href":"#a","x":"1","y":"1"}}),_c('use',{attrs:{"xlink:href":"#a","x":"2","y":"2"}})]),_c('use',{attrs:{"xlink:href":"#b","x":"3","y":"3"}}),_c('use',{attrs:{"xlink:href":"#b","x":"6","y":"6"}})])
          )
        }
      }
    